import Vue from 'vue';
import { getFollowIndustry, getFollowOrg, getFollowAuthor } from '@/apis/index';
const followAuthorList = {};
const followOrgList = {};
const followIndustryList = {};

function handleList(handle, followList) {
  // 格式化数据
  const arr = followList.map(item => item[handle.id]);
  arr.forEach(element => {
    // 数据存储进去
    Vue.set(handle.list, element, Vue.prototype[handle.name][element] || 0);
  });
  for (const key in handle.list) {
    // 遍历对象数据 如果对象里面有但是后端没有的话要置为false
    if (Object.prototype.hasOwnProperty.call(handle.list, key)) {
      let status = Vue.prototype[handle.name][key] || 0;
      status = status !== 0 ? 2 : 0;
      // 将对象数据处理为对应的状态
      Vue.set(handle.list, key, arr.includes(key) ? status : 1);
    }
  }
}

/**
 * 获取关注信息并且注册成响应式
 */
function getFollowInfo() {
  // 三个关注
  const handleObj = [
    // 行业
    {
      api: getFollowIndustry,
      id: 'industryId',
      list: followIndustryList,
      name: '$followIndustryList',
    },
    // 机构
    {
      api: getFollowOrg,
      id: 'orgId',
      list: followOrgList,
      name: '$followOrgList',
    },
    // 分析师
    {
      api: getFollowAuthor,
      id: 'authorId',
      list: followAuthorList,
      name: '$followAuthorList',
    },
  ];
  handleObj.forEach(handle => {
    handle.api({}).then(res => {
      if (res.statusCode === 0 && res.data.followList) {
        handleList(handle, res.data.followList);
      }
    });
  });
}
/**
 * 注册 Vue 全局属性 关注信息
 * @param {any} Vue
 */
export function syncFollow() {
  // 全局关注的作者列表
  Vue.prototype.$followAuthorList = Vue.observable(followAuthorList);
  // 全局关注的机构列表
  Vue.prototype.$followOrgList = Vue.observable(followOrgList);
  // 全局关注的行业列表
  Vue.prototype.$followIndustryList = Vue.observable(followIndustryList);
  Vue.prototype.$syncFollow = getFollowInfo;
}
